export const ADD_CUSTOMER = "ADD_CUSTOMER"
export const ADD_TO_CART = "ADD_TO_CART"
export const ADD_ALL_TO_CART = "ADD_ALL_TO_CART"
export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST"
export const REMOVE_FROM_CART = "REMOVE_FROM_CART"
export const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST"
export const EMPTY_CART = "EMPTY_CART"
export const CONTENT_STATE = "CONTENT_STATE";
